/* WHAT'S IN THE KIT (snippets/hk-kit-contents.liquid): highlight the option-driven parts that match the Build your kit selects.
 * Reads select[data-hk-option-name] (hk-option-picker) in the same section; falls back to Warehouse's own option inputs. */
(function () {
  var TICK = '<span class="hk-kc__tick" aria-hidden="true"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span>';
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function selections(scope) {
    var out = {};
    scope.querySelectorAll('select[data-hk-option-name]').forEach(function (s) {
      var o = s.options[s.selectedIndex];
      if (s.value && o) out[s.getAttribute('data-hk-option-name')] = o.getAttribute('data-hk-name') || o.text.trim();
    });
    // Fallback (products without the hk picker): Warehouse option selects / checked swatches with a data-option-position + label.
    scope.querySelectorAll('.product-form__option').forEach(function (box) {
      var name = (box.querySelector('.product-form__option-name, .product-form__option-label') || {}).textContent;
      var checked = box.querySelector('input:checked');
      if (name && checked) { name = name.split(':')[0].trim(); if (!out[name]) out[name] = checked.value; }
    });
    // Front Load "I'm not sure" (Reade 13 Oct 2026): the variant is the No Load spring, so highlight the No Load rows; staff confirm.
    if (/^I.m not sure/i.test(out['Front Load'] || '')) { out['Front Load'] = 'No Load'; out.__flUnsure = true; }
    return out;
  }

  function apply(card) {
    var scope = card.closest('.shopify-section') || document;
    var sel = selections(scope);
    // Folded option values "<Body> · <range>" (LC79): each row shows the range(s) for the chosen Body Type.
    var body = sel['Body Type'] || '';
    card.querySelectorAll('.hk-kc__opt').forEach(function (row) {
      var vals = []; try { vals = JSON.parse(row.getAttribute('data-kc-values') || '[]'); } catch (e) {}
      var ob = row.closest('[data-kc-option]'); if (ob && ob.getAttribute('data-kc-option').indexOf(' + ') > -1) return;   // composite rows are not folded
      if (!vals.some(function (v) { return String(v).indexOf(' · ') > -1; })) return;
      row.setAttribute('data-kc-folded', '');
      // No body yet: no range label (logo + SKU only). Body chosen: that body's range (span for multi-value rows, e.g. U-bolts 0-600kg).
      var mv = body ? vals.filter(function (v) { return v.indexOf(body + ' · ') === 0; }).map(function (v) { return v.slice(body.length + 3); }) : [];
      var lab = !mv.length ? '' : mv.length === 1 ? mv[0] : mv[0].split('-')[0] + '-' + mv[mv.length - 1].split('-').pop();
      row.setAttribute('data-kc-label', lab);
      var r = row.querySelector('.hk-kc__range'); if (r) { r.textContent = lab; r.title = lab; }
    });
    card.querySelectorAll('[data-kc-option]').forEach(function (box) {
      if (!box.classList.contains('hk-kc__opts')) return;
      var opt = box.getAttribute('data-kc-option');
      // Composite "Engine Type + Front Load" (Amarok, 12 Oct 2026): value = chosen values joined with " · " (empty until all are chosen).
      var parts = opt.indexOf(' + ') > -1 ? opt.split(' + ') : null;
      var val = parts ? (parts.every(function (n) { return sel[n]; }) ? parts.map(function (n) { return sel[n]; }).join(' · ') : '') : sel[opt];
      var optLabel = parts ? parts.join(' & ') : opt;
      var needs = box.querySelector('[data-kc-folded]') && !body ? 'Body Type & ' + optLabel : optLabel;   // folded rows wait for Body Type too
      var match = null;
      box.querySelectorAll('.hk-kc__opt').forEach(function (row) {
        var values = []; try { values = JSON.parse(row.getAttribute('data-kc-values') || '[]'); } catch (e) {}
        var on = !!val && values.indexOf(val) !== -1;
        row.classList.toggle('is-on', on);
        row.classList.toggle('is-off', !!val && !on);
        var st = row.querySelector('[data-kc-state]');
        if (st) st.innerHTML = !val ? 'Depends on ' + esc(needs) : on ? TICK + '<span>Included<span class="hk-kc__state-x"> with your selection</span></span>' : 'Not included';
        if (on && !match) match = row;
      });
      var because = box.parentNode.querySelector('[data-kc-because]');
      if (because) {
        if (match && sel.__flUnsure && (parts || [opt]).indexOf('Front Load') > -1) {
          because.innerHTML = esc(match.getAttribute('data-kc-brand') || '') + ' <b>' + esc(match.getAttribute('data-kc-label') || '') + '</b> ' + esc(match.getAttribute('data-kc-sku') || '') +
            ', the No Load spring for your <b>I\u2019m not sure</b> Front Load choice. Our team will contact you before building your kit to confirm the right spring.';
        } else if (match) {
          var label = match.getAttribute('data-kc-label') || '';
          because.innerHTML = esc(match.getAttribute('data-kc-brand') || '') + ' <b>' + esc(label) + '</b> ' + esc(match.getAttribute('data-kc-sku') || '') +
            ', matched to your <b>' + esc(parts ? val.replace(/ · /g, ' + ') : val) + '</b> ' + (label === val ? esc(opt) + ' choice' : 'choice');
        } else if (val) {
          because.textContent = 'No part listed for ' + (parts ? val.replace(/ · /g, ' + ') : val);
        } else {
          because.textContent = 'Choose ' + needs.replace(' & ', ' and ') + ' above to see which one is included';
        }
      }
    });
    stockNote(card);
  }

  // Kit stock note (Reade 15 Oct 2026): informational only. Shows when a part INCLUDED in the current selection has an out-of-stock dot.
  // Skips: option rows that are not ticked (Not included / undecided), hidden rows (other step groups, KDSS), rows replaced by KDSS, low stock,
  // and pills without a dot (unlinked / SKU TBA). Either-brand rows count only when every brand in the row is out.
  function stockNote(card) {
    var note = card.querySelector('[data-kc-stocknote]'); if (!note) return;
    var hit = false, seenEither = [];
    card.querySelectorAll('.hk-kc__list [data-kc-stock="out"]').forEach(function (dot) {
      if (hit) return;
      if (dot.closest('[hidden]')) return;
      var rep = dot.closest('[data-hk-kdss-replaced]');
      if (rep) { var rn = rep.querySelector('[data-hk-kdss-replaced-note]'); if (rn && !rn.hidden) return; }
      var opt = dot.closest('.hk-kc__opt'); if (opt && !opt.classList.contains('is-on')) return;
      var either = dot.closest('.hk-kc__either');
      if (either) {
        if (seenEither.indexOf(either) > -1) return; seenEither.push(either);
        var chips = either.querySelectorAll('.hk-kc-chip');
        for (var i = 0; i < chips.length; i++) { var d = chips[i].querySelector('[data-kc-stock]'); if (!d || d.getAttribute('data-kc-stock') !== 'out') return; }
      }
      hit = true;
    });
    note.hidden = !hit;
  }

  function applyAll() { document.querySelectorAll('[data-hk-kit]').forEach(apply); }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && (t.matches('select[data-hk-option-name]') || t.closest('.product-form__option'))) setTimeout(applyAll, 0);
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyAll); else applyAll();
  window.addEventListener('pageshow', applyAll);
})();

/* Kit SKU copy button (custom.kit_sku header) */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-kc-sku-copy]'); if (!b) return;
  var sku = (b.parentNode.querySelector('[data-kc-kit-sku]') || {}).textContent || '';
  var done = function () { b.textContent = 'Copied'; setTimeout(function () { b.textContent = 'Copy'; }, 1800); };
  if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(sku.trim()).then(done, done);
  else { var t = document.createElement('textarea'); t.value = sku.trim(); document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (x) {} t.remove(); done(); }
});
